import type { AppState } from "@strands/agent-transport";
import type { MessageInfo, Part } from "../types";

// ---------------------------------------------------------------------------
// Session state — one per session, cached when switching
// ---------------------------------------------------------------------------
//
// `pendingTools` (client-declared frontend tools like `question`) is
// deliberately NOT here — it belongs to the ChatPage UI lifecycle, not to a
// specific session. ChatPage registers the catalog from
// `frontendToolsQueryOptions` once it resolves; if we kept the list
// per-session, every `setActiveSession` would Object.assign a fresh empty
// list over it and the next run would miss `question` until the page is
// remounted. See `pendingTools` on the top-level ChatStore.

export interface SessionState {
  messages: MessageInfo[];
  partsMap: Record<string, Part[]>;
  streaming: boolean;
  activeRunId: string | null;
  error: string | null;
  appState: AppState;
  /** Raw args accumulation buffer keyed by toolCallId */
  toolCallArgsBuffer: Record<string, string>;
  /** Whether we're currently inside a REASONING block */
  inReasoning: boolean;
}

export const INITIAL_SESSION_STATE: SessionState = {
  messages: [],
  partsMap: {},
  streaming: false,
  activeRunId: null,
  error: null,
  appState: {},
  toolCallArgsBuffer: {},
  inReasoning: false,
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/** Get or create parts array for a message. Mutates draft (Immer-safe). */
export function getOrCreateParts(
  partsMap: Record<string, Part[]>,
  messageId: string,
): Part[] {
  if (!partsMap[messageId]) {
    partsMap[messageId] = [];
  }
  return partsMap[messageId]!;
}
